import React, { FC } from 'react';

import { Svg, SvgProps } from '@lglp/components';

import styles from './ErrorIcon.module.scss';

const ErreurIcon: FC<ErreurIconProps> = ({ className, ...rest }) => {
  return (
    <Svg
      viewBox="0 0 516.924 147"
      className={[styles.errorIcon, className]}
      {...rest}
    >
      <g transform="translate(1.5 1.5)">
        <g transform="translate(437.343 31.738)">
          <path
            d="M0 0H23.533V14.575H0z"
            className={styles.cls1}
            transform="translate(0 23.432)"
          />
          <g fill="none" stroke="#215382" strokeWidth="1.5px">
            <path
              d="M0 0H23.533V14.626H0z"
              className={styles.cls6}
              transform="translate(0 68.568)"
            />
            <path
              d="M0.75 0.75H22.783V13.876H0.75z"
              transform="translate(0 68.568)"
            />
          </g>
          <g fill="none">
            <path
              d="M904.95 838.416l-.555-.81c10.34-4.993 16.282-14.025 16.282-26.267 0-19.015-14.261-30.781-36.962-30.781h-38.032v19.514h23.532v-.972h13.073c9.747 0 14.619 4.516 14.619 12.241 0 7.607-4.873 12.123-14.619 12.123h-13.073v-.979h-23.532v20.151h23.532v-.989h12.835l.673.985c3.523-.04 14.923-.466 22.085-4.141.049-.026.092-.052.142-.075z"
              className={styles.cls6}
              transform="translate(-845.683 -780.558)"
            />
            <path
              d="M867.715 841.134v-.989h15.128l.446.654.217.317c3.745-.088 12.798-.59 19.21-3.306l-.546-.796 1.572-.759c4.95-2.39 8.786-5.708 11.401-9.863 2.677-4.25 4.033-9.315 4.033-15.053 0-4.475-.825-8.586-2.452-12.219-1.588-3.545-3.934-6.623-6.974-9.148-6.233-5.178-15.236-7.914-26.036-7.914h-36.531v16.514h20.532v-.974h14.573c5.157 0 9.175 1.206 11.943 3.586 1.392 1.197 2.453 2.684 3.154 4.422.678 1.682 1.022 3.61 1.022 5.733 0 2.095-.344 4.003-1.024 5.67-.703 1.721-1.764 3.197-3.156 4.385-2.774 2.368-6.79 3.568-11.939 3.568h-14.573v-.98h-20.532v17.152h20.532m1.5 1.5h-23.532v-20.151h23.532v.979h13.073c9.747 0 14.62-4.516 14.62-12.123 0-7.725-4.873-12.241-14.62-12.241h-13.073v.974h-23.532v-19.514h38.031c22.701 0 36.962 11.766 36.962 30.78 0 12.243-5.942 21.275-16.281 26.268l.555.81c-.049.023-.093.05-.141.073-7.162 3.675-18.562 4.1-22.086 4.141l-.672-.985h-12.836v.989z"
              className={styles.cls3}
              transform="translate(-845.683 -780.558)"
            />
          </g>
          <path
            d="M897.261 827.679c-6.577 3.358-15.832 4.254-21.205 4.479l11.8 17.276h25.195l-15.162-22.084c-.212.107-.412.225-.628.329z"
            className={styles.cls4}
            transform="translate(-836.39 -766.24)"
          />
          <path
            d="M0 0H25.506V15.62H0z"
            className={styles.cls4}
            transform="translate(-1.008 68.567)"
          />
          <path
            d="M921.856 811.574c0 12.263-5.968 21.9-16.821 27.138-7.679 3.944-20.243 4.153-22.737 4.153h-37.377v-20.151h37.573c8.92 0 13.635-3.853 13.635-11.14 0-9.325-7.418-11.271-13.635-11.271h-37.573V779.8l39 .013c23.4 0 37.935 12.172 37.935 31.761z"
            className={styles.cls4}
            transform="translate(-845.916 -780.79)"
          />
        </g>
        <text
          className={styles.cls2}
          fill="transparent"
          stroke="#215382"
          transform="translate(0 114)"
          strokeWidth="1.5px"
          fontFamily="Montserrat-ExtraBold, Montserrat"
          fontSize="118px"
          fontWeight="800"
        >
          <tspan x="0" y="0">
            ERREU
          </tspan>
        </text>
      </g>
    </Svg>
  );
};

type ErreurIconProps = SvgProps;

export default ErreurIcon;
